// eslint-disable-next-line
export default (props) => {
    return <div {...props} style={{ padding: "1rem", backgroundColor: "#eeeeee" }}>{props.children || "Empty"}</div>;
};
